/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awaiting_ApprovalInputs */

const th_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รอการอนุมัติ`)
};

const en_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting approval`)
};

const ja_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認待ち`)
};

const zh_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待批准`)
};

const es_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente de aprobación`)
};

const pt_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguardando aprovação`)
};

const id_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu persetujuan`)
};

const fr_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente d’approbation`)
};

const tl_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naghihintay ng pag-apruba`)
};

const vi_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ duyệt`)
};

const ko_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`승인 대기 중`)
};

const de_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartet auf Freigabe`)
};

const ru_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожидает одобрения`)
};

const tr_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onay bekliyor`)
};

const it_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In attesa di approvazione`)
};

const pl_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czeka na zatwierdzenie`)
};

const uk_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очікує схвалення`)
};

const hi_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकृति की प्रतीक्षा`)
};

const ar_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بانتظار الموافقة`)
};

const ms_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu kelulusan`)
};

const bn_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুমোদনের অপেক্ষায়`)
};

const zh_tw2_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待核准`)
};

const zh_hk2_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待核准`)
};

const ur_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منظوری کے انتظار میں`)
};

const fa_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در انتظار تأیید`)
};

const sw_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inasubiri idhini`)
};

const nl_awaiting_approval = /** @type {(inputs: Awaiting_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wacht op goedkeuring`)
};

/**
* | output |
* | --- |
* | "Awaiting approval" |
*
* @param {Awaiting_ApprovalInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const awaiting_approval = /** @type {((inputs?: Awaiting_ApprovalInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awaiting_ApprovalInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_awaiting_approval(inputs)
	if (locale === "ja") return ja_awaiting_approval(inputs)
	if (locale === "zh") return zh_awaiting_approval(inputs)
	if (locale === "es") return es_awaiting_approval(inputs)
	if (locale === "pt") return pt_awaiting_approval(inputs)
	if (locale === "id") return id_awaiting_approval(inputs)
	if (locale === "fr") return fr_awaiting_approval(inputs)
	if (locale === "tl") return tl_awaiting_approval(inputs)
	if (locale === "vi") return vi_awaiting_approval(inputs)
	if (locale === "ko") return ko_awaiting_approval(inputs)
	if (locale === "de") return de_awaiting_approval(inputs)
	if (locale === "ru") return ru_awaiting_approval(inputs)
	if (locale === "tr") return tr_awaiting_approval(inputs)
	if (locale === "it") return it_awaiting_approval(inputs)
	if (locale === "pl") return pl_awaiting_approval(inputs)
	if (locale === "uk") return uk_awaiting_approval(inputs)
	if (locale === "hi") return hi_awaiting_approval(inputs)
	if (locale === "ar") return ar_awaiting_approval(inputs)
	if (locale === "ms") return ms_awaiting_approval(inputs)
	if (locale === "bn") return bn_awaiting_approval(inputs)
	if (locale === "zh-TW") return zh_tw2_awaiting_approval(inputs)
	if (locale === "zh-HK") return zh_hk2_awaiting_approval(inputs)
	if (locale === "ur") return ur_awaiting_approval(inputs)
	if (locale === "fa") return fa_awaiting_approval(inputs)
	if (locale === "sw") return sw_awaiting_approval(inputs)
	if (locale === "nl") return nl_awaiting_approval(inputs)
	return en_awaiting_approval(inputs)
});